import { NgModule } from "@angular/core";
import { PayoutAccountDetailTileComponent } from "./payout-account-detail-tile/payout-account-detail-tile.component";
import { PaymentAccountDetailTileComponent } from "./payout-account-savings-tile/payment-account-detail-tile.component";
import { PayoutAddTileComponent } from "./payout-add-tile/payout-add-tile.component";
import { PayoutTileComponent } from "./payout-tile/payout-tile.component";
import { PaymentTileComponent } from "./payout-tile/payment-tile.component";
import { CoreModule } from "../../../core/core.module";
import { CardMaskDirective } from "./card-mask.directive";
import { WithdrawUnavailableModalComponent } from "./withdraw-unavailable-modal/withdraw-unavailable-modal.component";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";

const components = [
	PayoutAccountDetailTileComponent,
	PaymentAccountDetailTileComponent,
	PayoutAddTileComponent,
	PayoutTileComponent,
	PaymentTileComponent,
	WithdrawUnavailableModalComponent
];

const directives = [CardMaskDirective];

@NgModule({
	imports: [CoreModule, TermsAndConditionsUpdatesModule],
	declarations: [...components, ...directives],
	exports: [...components]
})
export class PayoutModule {}
